import Reveal from "./Reveal";
import { tc, tb } from "../lib/themeStyles";

const FERROUS = [
  "Carbon Steel (IS 2062, ASTM A36)",
  "Mild Steel",
  "Stainless Steel 304",
  "Stainless Steel 316",
  "Duplex Stainless 2205",
];
const NON_FERROUS = [
  "Aluminum 6061-T6 (Industrial)",
  "Aluminum 7075 (Aerospace grade)",
  "Copper (C11000)",
  "Brass (C26000)",
  "Specialized alloys on request",
];

function Pill({ label }) {
  return (
    <div className="material-pill">
      <span
        className="w-2 h-2 rounded-full shadow-[0_0_10px_rgba(59,130,246,0.5)] shrink-0"
        style={tb.accentBright}
      />
      <span className="text-[14px]" style={tc.primary}>
        {label}
      </span>
    </div>
  );
}

export default function MaterialsMatrix() {
  return (
    <section id="materials" className="section-shell">
      <div className="section-inner">
        <Reveal>
          <div className="label-cap mb-4" style={tc.accent}>
            03 — Materials Matrix
          </div>
          <h2 className="section-title max-w-[720px] mb-12">
            Stocks held. Grades certified. Mill test reports on request.
          </h2>
        </Reveal>

        <Reveal delay={100}>
          <div className="glass rounded-2xl p-8 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <h3 className="label-cap mb-6 flex items-center gap-3" style={tc.muted}>
                <span className="h-px w-8" style={tb.accentBright} />
                Ferrous Alloys
              </h3>
              <div className="flex flex-wrap gap-3">
                {FERROUS.map((m) => (
                  <Pill key={m} label={m} />
                ))}
              </div>
            </div>
            <div>
              <h3 className="label-cap mb-6 flex items-center gap-3" style={tc.muted}>
                <span className="h-px w-8" style={tb.accentBright} />
                Non-Ferrous Alloys
              </h3>
              <div className="flex flex-wrap gap-3">
                {NON_FERROUS.map((m) => (
                  <Pill key={m} label={m} />
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
